import { render } from "./DeleteFormModal.vue?vue&type=template&id=4e74fb02&scoped=true&ts=true"
import script from "./DeleteFormModal.vue?vue&type=script&lang=ts"
export * from "./DeleteFormModal.vue?vue&type=script&lang=ts"

import "./DeleteFormModal.vue?vue&type=style&index=0&id=4e74fb02&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e74fb02"]])

export default __exports__